import { defineMessages } from 'react-intl';

export const MESSAGES = defineMessages({
    supportedTypeFields: {
        defaultMessage: 'Supported type of fields',
        id: 'iaso.queryBuilder.supportedTypeFields',
    },
    xlsQuestionsTypesLink: {
        defaultMessage: 'Possible questions types',
        id: 'iaso.queryBuilder.xlsQuestionsTypesLink',
    },
});
